import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  FETCH_INBOXREQUEST_ACTION,
  FETCH_INBOXREQUEST_SUCCESS_ACTION,
  FETCH_INBOXREQUEST_FAIL_ACTION,
  FETCH_OUTBOXREQUEST_ACTION,
  FETCH_OUTBOXREQUEST_SUCCESS_ACTION,
  FETCH_OUTBOXREQUEST_FAIL_ACTION,
  DELETE_INBOX_INIT_ACTION,
  DELETE_INBOX_SUCCESS_ACTION,
  DELETE_INBOX_FAIL_ACTION,
  DELETE_OUTBOX_INIT_ACTION,
  DELETE_OUTBOX_SUCCESS_ACTION,
  DELETE_OUTBOX_FAIL_ACTION,
  FETCH_REQUEST_TYPE_IN_PARTNER_REQUEST_ACTION,
  FETCH_REQUEST_TYPE_IN_PARTNER_REQUEST_FAIL_ACTION,
  FETCH_REQUEST_TYPE_IN_PARTNER_REQUEST_SUCCESS_ACTION,
} from "./action";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
var btoa = require("Base64").btoa;

function* fetchinboxrequest(params) {
  let page = (params.params && params.params.page) || 1;
  let search = (params.params && params.params.search) || "";
  let filter = (params.params && params.params.filter) || "";
  let filterParam = "";
  let roleParam = ''
  if (filter) {
    filterParam = `&reqType=${filter}`;
  }
  if (params.params && params.params.role) {
    roleParam = `&role=${params.params.role}`;
  }

  try {
    const token = localStorage.getItem("token");
    let res = yield fetch(
      `${appConfig.ip}/parterReq/inbox?limit=10&page=${page}&ser=${search}${filterParam}${roleParam}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: FETCH_INBOXREQUEST_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    yield put({
      type: FETCH_INBOXREQUEST_FAIL_ACTION,
      error: err,
    });
  }
}

function* fetchoutboxrequest(params) {
  let page = (params.params && params.params.page) || 1;
  let search = (params.params && params.params.search) || "";
  let filter = (params.params && params.params.filter) || "";
  let filterParam = "";
  let roleParam = '';
  if (filter) {
    filterParam = `&reqType=${filter}`;
  }
  if (params.params && params.params.role) {
    roleParam = `&role=${params.params.role}`;
  }
  try {
    const token = localStorage.getItem("token");
    let res = yield fetch(
      `${appConfig.ip}/parterReq/outbox?limit=10&page=${page}&ser=${search}${filterParam}${roleParam}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      yield put({
        type: FETCH_OUTBOXREQUEST_SUCCESS_ACTION,
        payload: resJSON,
      });

    }
  } catch (err) {
    yield put({
      type: FETCH_OUTBOXREQUEST_FAIL_ACTION,
      error: err,
    });
  }
}

function* deleteinboxItem(value) {

  let id = value.value.item.id;

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/parterReq/` + id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      yield put({ type: FETCH_INBOXREQUEST_ACTION });
      yield put({
        type: DELETE_INBOX_SUCCESS_ACTION,
      });
      yield toast.success("Deleted successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: DELETE_INBOX_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* deleteoutboxItem(value) {

  let id = value.value.item.id;

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/parterReq/` + id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      yield put({ type: FETCH_OUTBOXREQUEST_ACTION });
      yield put({
        type: DELETE_OUTBOX_SUCCESS_ACTION,
      });
      yield toast.success("Deleted successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: DELETE_OUTBOX_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchRequestTypeInPartnerRequest() {
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/reqType?isActive=true`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch { }
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      let requestType = resJSON.rows.map((data) => {
        let requestTypes = {
          value: data.id,
          name: data.name,
        };
        return requestTypes;
      });

      yield put({
        type: FETCH_REQUEST_TYPE_IN_PARTNER_REQUEST_SUCCESS_ACTION,
        payload: resJSON,
        requestType: requestType,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_REQUEST_TYPE_IN_PARTNER_REQUEST_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

export function* PartnerRequestActionWatcher() {
  yield takeEvery(FETCH_INBOXREQUEST_ACTION, fetchinboxrequest);
  yield takeEvery(FETCH_OUTBOXREQUEST_ACTION, fetchoutboxrequest);
  yield takeEvery(DELETE_INBOX_INIT_ACTION, deleteinboxItem);
  yield takeEvery(DELETE_OUTBOX_INIT_ACTION, deleteoutboxItem);
  yield takeEvery(
    FETCH_REQUEST_TYPE_IN_PARTNER_REQUEST_ACTION,
    fetchRequestTypeInPartnerRequest
  );
}
